export const PWA_UPDATE_EVENT = 'pairferry:pwa-update';

export interface BeforeInstallPromptEvent extends Event {
  prompt(): Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed'; platform: string }>;
}

let serviceWorkerRegistration: ServiceWorkerRegistration | undefined;
let refreshing = false;

export function isStandaloneApp(): boolean {
  const iosStandalone = 'standalone' in navigator && Boolean((navigator as Navigator & { standalone?: boolean }).standalone);
  return window.matchMedia('(display-mode: standalone)').matches || iosStandalone;
}

export async function registerPwa(): Promise<void> {
  if (!('serviceWorker' in navigator)) return;
  serviceWorkerRegistration = await navigator.serviceWorker.register('/sw.js');
  const announceUpdate = () => window.dispatchEvent(new Event(PWA_UPDATE_EVENT));
  if (serviceWorkerRegistration.waiting) announceUpdate();
  serviceWorkerRegistration.addEventListener('updatefound', () => {
    const installing = serviceWorkerRegistration?.installing;
    installing?.addEventListener('statechange', () => {
      if (installing.state === 'installed' && navigator.serviceWorker.controller) announceUpdate();
    });
  });
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });
  await serviceWorkerRegistration.update().catch(() => undefined);
}

export function activatePwaUpdate(): boolean {
  const waiting = serviceWorkerRegistration?.waiting;
  if (!waiting) return false;
  waiting.postMessage({ type: 'SKIP_WAITING' });
  return true;
}
